/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportConfigurationForAssessment extends models.BaseReportConfigurationForAssessmentAgent {
    constructor() {
        super();
        this.setDiscriminator("ReportConfigurationForAssessment");
    }

    getFixupPrototypeFunction() { return ReportConfigurationForAssessment.fixupPrototype; }

    static newInstance(model: Partial<ReportConfigurationForAssessment>): ReportConfigurationForAssessment {
        let obj = Object.assign(new ReportConfigurationForAssessment(), model);
        ReportConfigurationForAssessment.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportConfigurationForAssessment>): ReportConfigurationForAssessment {
        if (!model) return null;
        return ReportConfigurationForAssessment.newInstance(<ReportConfigurationForAssessment> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportConfigurationForAssessment) {
        if (!obj) return;

        models.ReportConfigurationForAssessment.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportConfigurationForAssessment): boolean {
        if (models.BaseReportConfigurationForAssessmentAgent.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ReportConfigurationForAssessment.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
